<template>
  <v-text-field
    :value="value"
    @input="onInput"
    @change="onChange"
    v-bind="$attrs"
    v-on="$listeners"
    :rules="rules"
  ></v-text-field>
</template>
<script>
export default {
  name: "KeyField",
  props: {
    value: String,
    rules: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data: () => ({}),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    onChange(obj) {
      this.$emit("change", obj);
    }
  }
};
</script>
